module.exports = __webpack_public_path__ + "media/le-reshop/homme-e42bf909.png";